





















































































import Vue from 'vue';
import { mapGetters } from "vuex";
import {
  ACCOUNT_CREATED,
  LinkRequest,
  LinkRequestStatus,
  REQUEST_ACCEPTED,
  REQUEST_DECLINED
} from "@/common/types/BrokerLinks";
import {
  DEPOT_STORE,
  FETCH_LINKREQUESTS,
  LinkRequestFetchParameter,
  DEPOT,
  LINKREQUESTS,
  LINKREQUESTS_LOADING,
  LINKREQUEST_IS_PENDING,
  LINKREQUEST_IS_CREATED,
  UPDATE_LINKREQUEST, LinkRequestUpdateParameter, LINKREQUEST_SAVED, LINKREQUEST_IS_DECLINED
} from "@/common/store/modules/DepotStore";
import OctEditAccountNumberDialog from '@/components/Depot/OctEditAccountNumberDialog.vue';


export default Vue.extend({
  components: { OctEditAccountNumberDialog },
  name: "OctBrokerConnectionTimeline",
  computed: {
    ...mapGetters(DEPOT_STORE, [LINKREQUESTS_LOADING, LINKREQUESTS, DEPOT, LINKREQUEST_IS_PENDING, LINKREQUEST_IS_CREATED, LINKREQUEST_SAVED, LINKREQUEST_IS_DECLINED]),
  },
  data () {
    return {
      editAccountNumberDialogOpen: false,
    };
  },
  methods: {
    getTimelineColor(brokerConnection: LinkRequest) {
      switch (brokerConnection.status) {
      case ACCOUNT_CREATED:
        return "grey";
      case REQUEST_DECLINED:
        return "red";
      case REQUEST_ACCEPTED:
        return "green";
      default:
        return "orange";
      }
    },
    updateLinkRequest(targetStatus: LinkRequestStatus) {
      this.$store.dispatch(UPDATE_LINKREQUEST, { targetStatus: targetStatus, linkRequest: this.LINKREQUESTS[0].accountNo } as LinkRequestUpdateParameter);
    },
  },
  watch: {
    [LINKREQUEST_SAVED] (newValue, oldValue) {
      if(newValue) {
        this.$store.dispatch(FETCH_LINKREQUESTS, { requesterId: this.$route.params.id } as LinkRequestFetchParameter);
      }
    }
  },
  mounted(): void {
    this.$store.dispatch(FETCH_LINKREQUESTS, { requesterId: this.$route.params.id } as LinkRequestFetchParameter);
  }
});
